import "./inc/retail_user.js";
import "./inc/instant_access.js";
import "./inc/masterplan_modal.js";
import "./inc/map_infowindow.js";
import "./inc/map_pin_scale.js";
import "./inc/location_search.js";
import { initHubspotForms } from "./inc/hubspot_forms.js";
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";
// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from "swiper/bundle";
window.Swiper = Swiper;

initHubspotForms();

// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = "#" + triggerEl.href.split("#")[1];
    var tabBtn = document.querySelector(hash + "-tab");

    triggerEl.addEventListener("click", function (event) {
        event.preventDefault();
        tabBtn.click();
    });
});
// END Trigger Tabs By Hash
// ========================

// ========================
// == Read More Toggle

document.querySelectorAll("[data-read-more]").forEach(function (container) {
    if (container.textContent.trim().length > 890) {
        container.classList.add("is-collapsed");

        const btn = document.createElement("button");
        btn.className = "read-more-btn";
        btn.innerHTML = 'Read More <i class="fa-regular fa-chevron-down"></i>';

        btn.addEventListener("click", function () {
            const collapsed = container.classList.toggle("is-collapsed");
            btn.innerHTML = collapsed
                ? 'Read More <i class="fa-regular fa-chevron-down"></i>'
                : 'Read Less <i class="fa-regular fa-chevron-up"></i>';
        });

        container.after(btn);
    }
});

// END Read More Toggle
// ========================

// ========================
// == Add class to main navbar on scroll

const navbar = document.querySelector("#site-nav");

window.addEventListener("scroll", function () {
    let scroll = window.scrollY;
    if (scroll > navbar.offsetTop) {
        navbar.classList.add("scrolled");
    } else {
        navbar.classList.remove("scrolled");
    }
});

// END scrolled
// ========================

// ========================
// == Panzoom =============

const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector(".panzoom__content");
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    });
}

for (const link of fpImgLink) {
    link.addEventListener("click", function () {
        fpImgLink.forEach((e) => {
            e.classList.remove("active-bg");
        });
        link.classList.add("active-bg");
        var imgUrl = link.dataset.imgurl;
        console.log(imgUrl);
        panZoomImg.src = imgUrl;
    });
}

// END Panzoom ============
// ========================

// ========================
// == Map Controls ========
// ISP-style zoom in/out/re-center controls for a Google oimap. The container's
// data-oi-map-controls="{map element id}" names the map; each button's
// data-oi-map-control is "in", "out", or "fit". Clicks are delegated so lazy-loaded
// maps work; they're a no-op until the map has loaded.

function getLoadedMap(map_id) {
    return (oi.loaded && oi.loaded.map && oi.loaded.map[map_id]) || null;
}

document.addEventListener("click", function (event) {
    const btn = event.target.closest("[data-oi-map-control]");
    const controls = btn && btn.closest("[data-oi-map-controls]");
    if (!controls) return;
    const map_wrap = getLoadedMap(controls.dataset.oiMapControls);
    if (!map_wrap || !map_wrap.map) return;

    const action = btn.dataset.oiMapControl;
    if (action === "fit") {
        map_wrap.fit();
    } else {
        map_wrap.map.setZoom(map_wrap.map.getZoom() + (action === "in" ? 1 : -1));
    }
});

// The custom controls replace Google's zoom control. oilib dispatches its loaded
// event just before it builds the Google map, so wait a tick before hiding it.
document.querySelectorAll("[data-oi-map-controls]").forEach(function (controls) {
    const map_id = controls.dataset.oiMapControls;
    const hideZoomControl = function () {
        setTimeout(function () {
            const map_wrap = getLoadedMap(map_id);
            if (map_wrap && map_wrap.map) map_wrap.map.setOptions({ zoomControl: false });
        });
    };
    if (getLoadedMap(map_id)) {
        hideZoomControl();
    } else {
        window.addEventListener("oi.loaded.map." + map_id, hideZoomControl, { once: true });
    }
});

// END Map Controls =======
// ========================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false;

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
};

// Bind actions to Fancybox events
const fancyboxEvents = {
    initCarousel: (fancybox) => {
        if (!fancyboxEventBlock) {
            // Block additional Fancybox events
            fancyboxEventBlock = true;

            // Do Fancybox event
            doFancyboxOiEvent(fancybox);

            // Undo the event block after 1 second.
            setTimeout(() => {
                fancyboxEventBlock = false;
            }, 1000);
        }
    },
    done: (fancybox, slide) => {
        if (!fancyboxEventBlock) {
            // Do Fancybox event
            doFancyboxOiEvent(fancybox);
        }
        // Panzoom was initialized while the ajax slide was still hidden, so it
        // measured a zero-size viewport. Recalculate now that the slide is in place.
        if (slide.oiPanzoom) {
            slide.oiPanzoom.updateMetrics();
        }
    },
    reveal: (fancybox, slide) => {
        // Gallery modal slides (ajax .media-modal) carry an .f-panzoom block; make it
        // zoomable/pannable. Plain image slides have none, so this is a no-op there.
        const panzoomContainer = slide.el && slide.el.querySelector(".f-panzoom");
        if (panzoomContainer) {
            slide.oiPanzoom = new Panzoom(panzoomContainer, {
                minScale: 0.5,
            });
        }
    },
    destroy: () => {
        // Reset the block on Fancybox close.
        fancyboxEventBlock = false;
    },
};

Fancybox.bind('[data-fancybox]:not([data-fancybox="gallery"]):not([data-fancybox="fsg-gallery"])', {
    on: fancyboxEvents,
});

// The detail pages' full-screen gallery modal already shows every image, so its
// Fancybox doesn't need the thumbnail filmstrip either.
Fancybox.bind('[data-fancybox="fsg-gallery"]', {
    Thumbs: false,
    on: fancyboxEvents,
});

// The thumbnail filmstrip is off for the photo gallery's AssetModal (.media-modal):
// every asset on the page shares this "gallery" group, so the filmstrip isn't part of
// its design and was pushing the slide taller than the viewport.
Fancybox.bind('[data-fancybox="gallery"]', {
    Thumbs: false,
    on: fancyboxEvents,
});

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener(
    "load",
    function () {
        oi.utils.wrap_oi_aspect();
    },
    false,
);
